import { inject, Injectable } from '@angular/core';
import { CurrentUserService } from '@rma/accounts/user';
import { rmaShareReplay } from '@rma/common-ui-rxjs/operators';
import { Observable, of, switchMap } from 'rxjs';
import { SubscriptionApiService } from '../data-access/subscription-api.service';
import { SubscriptionPlanAccess } from './subscription-plan-access.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionFeatureService {
  private readonly subscriptionApiService = inject(SubscriptionApiService);
  private readonly userService = inject(CurrentUserService);

  public get currentAccess$(): Observable<SubscriptionPlanAccess | undefined> {
    return this.userService.currentUserContext$.pipe(
      switchMap((currentUserContext) => {
        if (currentUserContext === null || currentUserContext?.userType === 'Consumer') {
          return of(undefined);
        }
        return currentUserContext.userType === 'Agent'
          ? this.subscriptionApiService.getCurrentAgentAccess()
          : this.subscriptionApiService.getAgencyAccess(currentUserContext.profileCode);
      }),
      rmaShareReplay(),
    );
  }
}
